import Browser from 'browser-detect';

const MINIMUM_VERSIONS = {
  ie: 11,
  safari: 9,
  chrome: 43,
  firefox: 44,
  android: 4.4
};

function getEnvironment() {
  const meta = document.querySelector('meta[name="server-environment"]');

  return meta ? meta.getAttribute("content") : undefined;
}

const isDataSaving = () => document.documentElement.hasAttribute("data-save-data");

const isDevelopment = () => getEnvironment() === 'development';

const isProduction = () => getEnvironment() === 'production';

function isSupportedBrowser() {
  const { mobile, name, versionNumber } = Browser();
  const minimumVersionNumber = MINIMUM_VERSIONS[name] || 0;

  return !(mobile && name === 'opera') && (versionNumber >= minimumVersionNumber);
}

export {
  getEnvironment,
  isDataSaving,
  isDevelopment,
  isProduction,
  isSupportedBrowser
};



// WEBPACK FOOTER //
// ./shared/helpers/environment.js